"use client";

import { cn } from "@repo/shared/utils";
import { type VariantProps, cva } from "class-variance-authority";
import type {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from "react";

const footerVariants = cva(
  "p-4 flex flex-row justify-between text-sm shadow-xl",
  {
    variants: {
      variant: {
        default: "bg-primary-strong text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        tertiary: "bg-tertiary text-tertiary-foreground",
        accent: "bg-accent text-black font-bold",
        ghost: "text-black bg-white",
      },
      position: {
        sticky: "fixed bottom-0 left-0 right-0",
        floating: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface FooterProps
  extends PropsWithChildren,
    VariantProps<typeof footerVariants>,
    DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  sticky?: boolean;
}

export const Footer = ({
  children,
  variant,
  position,
  className,
  ...props
}: FooterProps) => {
  return (
    <footer
      className={cn(footerVariants({ variant, position, className }))}
      {...props}
    >
      {children}
    </footer>
  );
};
